/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UserManagementCreateUserResponse } from "./UserManagementCreateUserResponse";

export type UserManagementCreateUserResponseApiRespoonse = {
  data?: UserManagementCreateUserResponse;
  status?: UserManagementCreateUserResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace UserManagementCreateUserResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
